'use client';
import { Box } from '@chakra-ui/react';
import { getImageProps } from 'next/image';

import { getImageLink } from '@/services/link.service';
import { CallToAction } from '@/types/home/home.types';
import { directusImageLoader } from '@/utils/loaders';

const TradeInImage = ({
  trade_in_call_to_action,
  styles,
}: {
  trade_in_call_to_action: CallToAction;
  styles: any;
}) => {
  const imageKeys = { desktopKey: 'image-693-377', mobileKey: 'image-360-170' };
  const common = {
    alt: 'Hero',
    width: 693,
    height: 377,
    loader: directusImageLoader,
  };
  const {
    props: { srcSet: mobile },
  } = getImageProps({
    ...common,
    src: getImageLink(trade_in_call_to_action?.image)
      ? `${getImageLink(trade_in_call_to_action?.image)}?key=${imageKeys.mobileKey}`
      : '',
  });

  const {
    props: { srcSet: desktop, ...rest },
  } = getImageProps({
    ...common,
    src: getImageLink(trade_in_call_to_action?.image)
      ? `${getImageLink(trade_in_call_to_action?.image)}?key=${imageKeys.desktopKey}`
      : '',
  });

  const Styles = styles;

  return (
    <Box order={{ base: 1, md: 2 }}>
      <picture className={Styles.tradeInCarImg}>
        <source media="(max-width: 575px)" srcSet={mobile} />
        <source media="(min-width: 576px)" srcSet={desktop} />
        <img {...rest} alt="trad-in-image" />
      </picture>
    </Box>
  );
};

export default TradeInImage;
